<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="1440.000000pt" height="1440.000000pt"
        viewBox="0 0 1440.000000 1440.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,1440.000000) scale(0.100000,-0.100000)" fill="#ffffff" stroke="none">
            <path d="M7115 13025 c-71 -35 -168 -78 -215 -95 -98 -37 -314 -114 -380 -137
-286 -97 -750 -339 -1116 -579 -339 -224 -768 -582 -1183 -989 -410 -402 -690
-733 -976 -1155 -186 -273 -386 -634 -480 -865 -20 -49 -40 -99 -45 -110 -5
-11 -50 -126 -99 -255 -150 -397 -229 -557 -372 -754 l-58 -79 19 -51 c43
-119 71 -228 84 -341 15 -120 40 -459 51 -675 41 -839 89 -1270 184 -1642 38
-147 162 -578 237 -818 87 -280 271 -725 434 -1051 49 -96 175 -333 281 -525
358 -649 431 -805 524 -1115 l17 -56 96 -7 c89 -7 238 -31 337 -56 22 -5 99
-23 170 -41 72 -17 186 -47 255 -66 69 -19 139 -39 155 -43 17 -4 102 -29 190
-55 88 -26 174 -51 190 -55 17 -4 57 -15 90 -24 363 -101 513 -129 985 -186
188 -23 643 -33 931 -21 280 11 336 16 629 52 461 57 892 146 1270 264 41 13
140 44 220 69 432 134 610 172 843 179 l79 2 33 130 c60 234 151 434 410 905
86 157 179 332 207 390 55 116 120 245 165 330 42 79 124 267 210 480 199 497
391 1171 458 1610 9 58 20 132 25 165 5 33 12 96 15 140 3 44 10 114 16 155
17 132 53 862 50 1035 -2 164 59 641 90 697 5 10 9 23 9 30 0 7 18 52 39 101
l39 87 -63 93 c-126 185 -209 358 -390 812 -131 327 -155 378 -320 680 -263
481 -631 999 -962 1355 -38 41 -107 122 -153 180 -84 105 -444 473 -554 565
-55 47 -127 108 -186 159 -46 39 -294 223 -350 258 -30 20 -98 60 -150 90 -52
30 -127 74 -167 97 -105 60 -578 301 -718 364 -66 30 -145 66 -175 79 -30 14
-147 65 -260 113 -234 100 -349 155 -436 208 -34 20 -70 37 -80 36 -11 0 -77
-29 -149 -64z m834 -577 c42 -22 96 -52 121 -65 97 -53 150 -126 150 -208 0
-142 -171 -440 -285 -495 -73 -35 -123 -26 -281 55 -73 37 -140 72 -148 79
-13 9 10 59 161 344 109 205 182 332 191 332 8 0 49 -19 91 -42z m-1279 -16
c36 -18 104 -98 95 -112 -7 -11 -115 -70 -128 -70 -5 0 -22 14 -37 30 -35 37
-72 39 -105 5 -32 -31 -32 -70 0 -99 30 -28 51 -33 204 -46 146 -14 193 -34
235 -103 34 -56 46 -148 26 -197 -29 -70 -163 -162 -256 -176 -61 -9 -123 22
-168 83 -20 26 -36 53 -36 59 0 9 32 30 106 69 27 14 29 13 64 -25 46 -49 79
-52 121 -11 34 35 36 59 8 95 -25 32 -95 52 -210 60 -143 10 -204 39 -244 119
-70 141 13 281 195 333 50 14 78 11 130 -14z m1856 -317 c53 -34 55 -37 42
-58 -8 -12 -95 -156 -194 -321 -98 -164 -184 -300 -190 -303 -16 -6 -124 60
-124 77 0 8 86 158 191 333 134 223 195 317 205 313 8 -3 39 -21 70 -41z
m-2242 -295 c146 -129 266 -240 266 -247 0 -13 -110 -83 -132 -83 -7 0 -36 23
-63 50 -27 28 -55 50 -63 50 -14 0 -182 -106 -182 -115 0 -2 11 -34 25 -71 14
-36 25 -73 25 -80 0 -17 -122 -96 -132 -86 -6 6 -51 150 -183 577 -24 77 -46
147 -50 156 -5 13 14 30 81 72 l87 56 27 -22 c15 -12 147 -128 294 -257z
m2612 53 c148 -111 137 -102 168 -147 45 -67 33 -138 -41 -239 -49 -66 -113
-107 -170 -107 -50 0 -86 16 -161 72 -29 22 -59 37 -67 34 -7 -2 -45 -49 -84
-104 -97 -136 -91 -132 -156 -88 -30 21 -59 43 -64 50 -8 9 45 89 200 302 116
159 213 295 216 302 11 26 47 9 159 -75z m-3258 -67 c18 -24 32 -48 32 -53 0
-4 -27 -28 -60 -53 -33 -24 -60 -49 -60 -55 0 -5 48 -71 106 -145 127 -162
258 -332 267 -347 8 -12 -96 -103 -117 -103 -7 0 -59 60 -116 133 -247 315
-282 357 -294 349 -7 -4 -38 -27 -69 -51 l-57 -44 -23 29 c-43 54 -46 59 -47
70 0 6 73 67 163 137 89 69 176 137 192 151 17 14 35 25 41 26 6 0 25 -20 42
-44z m3773 -341 c45 -24 100 -76 131 -124 34 -55 38 -133 9 -196 -44 -96 -217
-293 -311 -354 -48 -31 -63 -36 -116 -35 -70 0 -123 26 -186 90 -81 81 -98
171 -49 265 49 95 199 272 284 334 72 53 159 60 238 20z m-4195 -138 c59 -67
133 -151 164 -187 31 -36 94 -107 138 -158 77 -87 93 -112 75 -112 -5 0 -30
-21 -56 -45 -27 -25 -50 -45 -52 -45 -7 0 -487 554 -493 569 -5 14 97 112 110
105 4 -3 55 -59 114 -127z m2039 17 c38 -71 160 -162 520 -390 174 -110 259
-168 357 -245 84 -66 214 -194 250 -246 13 -18 26 -33 30 -33 4 0 10 21 14 46
3 25 13 48 20 51 21 8 131 -59 214 -129 190 -163 369 -428 508 -753 127 -298
177 -503 223 -920 16 -143 16 -552 0 -680 -55 -438 -187 -774 -421 -1066 -236
-295 -615 -566 -1029 -733 -60 -24 -80 -39 -81 -58 0 -4 24 -14 54 -23 55 -16
87 -12 261 34 99 26 158 10 290 -79 99 -67 165 -97 242 -109 190 -30 311 -162
348 -381 17 -97 46 -193 76 -252 63 -124 184 -181 304 -144 27 8 51 13 54 11
15 -16 -86 -136 -167 -198 -136 -104 -258 -149 -422 -155 -207 -7 -328 42
-480 197 -129 131 -164 199 -299 586 -51 148 -118 271 -174 321 -27 24 -58 44
-68 44 -23 0 -26 23 36 -241 39 -170 48 -245 42 -369 -9 -187 -67 -342 -164
-438 -48 -47 -202 -162 -218 -162 -8 0 -238 -141 -271 -167 -19 -14 -43 -40
-54 -58 l-21 -33 -47 46 c-27 26 -62 54 -78 62 -87 45 -271 153 -326 193 -35
24 -96 75 -136 112 -58 54 -80 83 -112 149 -64 134 -75 183 -74 336 0 125 4
149 47 332 26 108 47 203 47 212 0 25 -16 19 -62 -21 -76 -69 -131 -178 -218
-433 -93 -271 -159 -389 -284 -508 -85 -81 -205 -146 -301 -163 -99 -18 -267
-6 -355 26 -111 40 -193 89 -269 161 -69 65 -128 140 -119 150 3 3 33 0 67 -6
104 -19 184 8 243 82 56 70 101 187 118 307 18 130 73 240 151 303 63 51 98
67 201 89 101 22 144 41 238 107 137 95 197 109 325 71 88 -27 233 -36 257
-17 34 25 12 53 -65 82 -134 52 -375 177 -494 256 -440 293 -704 649 -837
1128 -66 237 -89 430 -89 747 0 363 33 668 99 903 159 570 451 1045 752 1221
29 17 59 31 67 31 8 0 19 -21 26 -51 l13 -50 51 58 c142 164 285 274 625 483
343 210 463 299 510 375 12 19 25 35 29 35 3 0 15 -16 26 -36z m-2342 -173
c14 -5 41 -24 61 -42 l37 -32 -53 -54 c-29 -29 -57 -53 -63 -53 -5 0 -21 9
-35 20 -34 26 -66 25 -95 -5 -30 -29 -32 -64 -7 -95 26 -33 96 -36 219 -11
121 25 152 26 201 6 45 -19 76 -48 110 -100 21 -32 26 -53 27 -100 0 -53 -5
-67 -40 -119 -47 -71 -138 -141 -195 -151 -23 -4 -55 -2 -77 5 -39 13 -123 74
-123 90 0 9 96 103 111 108 5 2 23 -8 40 -22 40 -34 79 -33 113 0 41 42 32 94
-21 122 -27 15 -106 15 -153 2 -51 -15 -182 -24 -224 -16 -73 14 -156 119
-156 197 0 75 100 208 183 244 37 16 105 19 140 6z m4971 -153 c36 -40 66 -76
66 -80 0 -8 -209 -420 -247 -486 -14 -24 -23 -45 -21 -47 3 -4 156 140 315
298 l93 91 50 -49 c27 -27 50 -54 49 -60 0 -5 -83 -86 -185 -180 -101 -93
-223 -207 -271 -252 -49 -45 -93 -82 -98 -83 -10 0 -86 75 -128 126 -18 21
-16 27 102 260 66 132 132 258 146 282 32 52 20 54 -27 5 -19 -21 -113 -114
-208 -206 l-173 -169 -49 49 c-27 26 -47 53 -46 60 4 18 538 513 553 513 8 0
43 -32 79 -72z m-5409 -318 c54 -26 143 -116 154 -156 5 -17 6 -43 4 -58 -5
-25 -4 -26 21 -16 64 24 100 9 212 -86 36 -30 77 -60 90 -66 13 -6 24 -16 24
-22 0 -17 -89 -116 -104 -116 -12 0 -77 48 -174 126 -42 34 -84 35 -118 3 -53
-49 -53 -49 71 -159 129 -114 125 -100 51 -181 -21 -22 -42 -39 -46 -37 -5 2
-122 102 -261 223 -139 121 -266 232 -283 246 l-30 26 81 94 c170 196 216 223
308 179z m5908 -261 c136 -173 177 -228 177 -238 0 -10 -70 -71 -82 -71 -5 0
-40 41 -79 90 -39 50 -76 90 -83 90 -15 0 -126 -89 -126 -102 0 -5 27 -45 60
-87 33 -43 60 -83 60 -89 0 -11 -69 -72 -81 -72 -4 0 -37 38 -74 85 -37 47
-70 85 -73 85 -11 0 -153 -112 -158 -125 -3 -7 26 -54 65 -104 39 -50 71 -97
71 -104 0 -8 -20 -28 -44 -45 l-44 -32 -54 68 c-121 150 -190 238 -198 253 -7
13 23 41 157 145 91 71 191 149 223 174 166 130 206 159 215 157 6 -2 36 -37
68 -78z m-6321 -236 c7 -9 -9 -39 -61 -113 l-71 -100 68 -50 c37 -27 70 -49
74 -50 4 0 35 41 69 90 34 50 65 90 69 90 12 0 90 -60 90 -69 0 -5 -25 -44
-56 -87 -31 -43 -58 -83 -60 -89 -3 -6 24 -32 59 -57 80 -57 105 -71 117 -63
5 3 39 49 76 101 36 51 68 94 71 94 11 0 93 -64 93 -72 0 -10 -91 -145 -183
-271 -30 -41 -55 -66 -63 -63 -13 5 -155 102 -429 296 -88 62 -166 115 -172
117 -7 3 -13 9 -13 14 0 6 52 84 116 174 l116 165 40 -22 c21 -12 44 -28 50
-35z m6668 -282 c91 -54 162 -203 141 -295 -11 -44 -56 -104 -95 -126 -26 -14
-28 -14 -49 12 -12 15 -31 44 -42 64 l-20 37 32 26 c57 47 61 91 15 144 -38
43 -139 7 -322 -115 -96 -65 -120 -86 -135 -123 -18 -41 -9 -77 29 -121 l32
-38 63 38 c71 44 79 56 57 88 -9 12 -16 27 -16 33 0 15 90 69 99 59 29 -31
121 -188 114 -194 -15 -15 -316 -200 -324 -200 -15 0 -137 162 -169 224 -37
73 -43 153 -15 206 49 95 311 273 450 306 63 15 98 9 155 -25z m-6976 -218
c50 -49 136 -131 191 -183 235 -225 275 -264 275 -272 0 -4 -19 -42 -42 -84
l-43 -75 -35 6 c-31 6 -160 39 -305 79 -27 8 -122 33 -210 56 -156 41 -215 59
-215 66 0 2 16 33 36 69 22 41 42 65 53 65 16 0 94 -24 402 -125 75 -25 142
-45 149 -45 7 0 -18 25 -55 55 -37 31 -138 119 -225 196 -119 106 -157 146
-152 158 23 52 64 121 73 121 7 0 53 -39 103 -87z m5845 -409 c80 -90 116
-184 108 -278 -6 -71 -29 -145 -99 -311 -28 -66 -63 -156 -79 -200 -15 -44
-32 -81 -38 -83 -5 -2 -13 17 -16 42 -11 69 1 384 19 526 9 69 16 179 15 245
-1 66 -1 124 0 128 2 12 54 -28 90 -69z m1433 62 c62 -26 121 -100 151 -190
49 -144 -18 -233 -266 -356 -272 -135 -390 -113 -474 89 -65 158 1 253 270
388 157 79 248 98 319 69z m-6093 -441 c26 -176 25 -511 -1 -503 -6 2 -25 44
-43 93 -18 50 -55 142 -82 205 -75 173 -88 222 -88 325 0 81 3 95 30 144 17
30 59 84 95 120 l65 66 6 -190 c4 -104 12 -221 18 -260z m-1406 176 c111 -54
261 -127 332 -161 72 -35 133 -68 136 -73 8 -11 -46 -130 -60 -135 -5 -2 -121
51 -258 118 -136 67 -287 140 -335 163 -48 23 -87 48 -88 55 0 14 58 132 65
132 3 0 96 -44 208 -99z m6302 -208 c92 -126 107 -285 40 -427 -31 -65 -97
-141 -153 -176 -39 -24 -42 -29 -71 -137 -49 -173 -78 -228 -149 -270 -53 -32
-66 -30 -58 10 3 17 10 84 16 147 12 153 24 192 76 249 39 43 44 56 58 137 21
117 35 155 111 306 36 70 67 145 71 167 4 23 10 41 15 41 5 0 25 -21 44 -47z
m-5182 -5 c3 -24 33 -95 66 -159 69 -133 107 -240 117 -331 6 -54 12 -69 45
-104 66 -73 71 -92 89 -289 5 -60 13 -120 16 -132 17 -63 -99 7 -143 86 -15
26 -44 103 -63 171 -33 117 -36 123 -75 150 -175 121 -242 343 -157 523 28 61
76 127 92 127 4 0 10 -19 13 -42z m-1427 -23 c22 -9 48 -20 59 -24 49 -21 296
-115 458 -176 71 -27 131 -53 133 -59 2 -6 -11 -51 -30 -101 l-34 -90 -219 0
c-120 0 -264 3 -320 7 -99 7 -139 -2 -70 -16 17 -4 80 -24 140 -46 257 -95
324 -119 350 -126 15 -3 30 -10 33 -16 5 -8 -31 -114 -45 -130 -4 -4 -137 42
-296 102 -365 138 -415 160 -415 174 0 6 15 49 33 96 l34 85 316 0 c175 0 311
2 305 3 -12 4 -59 20 -353 127 -204 73 -187 64 -180 94 11 49 40 111 51 111 6
0 29 -7 50 -15z m8176 -200 c33 -88 51 -151 55 -196 5 -63 4 -67 -26 -101 -32
-37 -94 -68 -172 -88 -45 -11 -63 -8 -131 28 -5 2 -8 -4 -8 -13 0 -34 -32 -82
-68 -103 -20 -11 -64 -30 -97 -43 -33 -12 -79 -33 -103 -47 -24 -13 -44 -23
-46 -21 -7 8 -56 136 -56 146 0 12 50 37 154 79 75 30 106 56 106 90 0 29 -25
94 -37 94 -4 0 -68 -23 -142 -51 -152 -58 -146 -59 -179 33 -16 43 -18 58 -9
66 7 5 127 53 267 107 140 54 287 111 325 126 110 45 109 45 167 -106z m-1350
-292 c54 -117 62 -150 63 -248 0 -76 -4 -97 -25 -138 -48 -95 -159 -173 -304
-213 -101 -28 -153 -79 -301 -298 -50 -73 -120 -136 -152 -136 -21 0 -23 3
-17 28 28 110 122 305 203 419 33 45 64 99 71 120 24 75 59 140 111 209 50 66
298 333 310 334 3 0 22 -35 41 -77z m-5496 -73 c182 -194 259 -304 279 -400 4
-19 34 -71 67 -115 86 -115 231 -425 213 -455 -9 -15 -61 9 -97 44 -18 18 -70
84 -114 147 -130 183 -153 205 -259 240 -49 16 -109 39 -133 50 -212 103 -259
299 -135 557 20 40 39 72 43 70 5 -2 66 -64 136 -138z m6987 -181 c73 -38 132
-166 125 -270 -9 -128 -100 -192 -378 -267 -203 -55 -299 -32 -365 89 -36 67
-48 196 -22 245 36 70 107 116 262 169 187 64 298 74 378 34z m-8383 -58 c129
-33 255 -66 280 -75 66 -24 113 -61 139 -107 21 -36 23 -51 19 -122 -9 -168
-98 -276 -227 -277 -42 0 -564 123 -590 139 -14 9 16 141 35 148 6 2 122 -23
255 -56 134 -33 262 -63 284 -66 58 -9 93 8 111 52 21 50 9 91 -36 117 -19 11
-152 50 -297 87 -145 36 -265 68 -268 71 -6 6 19 120 30 137 3 6 12 11 18 11
7 0 118 -27 247 -59z m7094 -283 c56 -233 -34 -432 -244 -538 -73 -37 -148
-59 -254 -75 -125 -19 -153 -33 -319 -151 -161 -116 -258 -166 -332 -172 -30
-2 -62 -1 -71 2 -16 6 -15 8 4 22 30 21 71 83 131 199 62 119 94 155 161 179
68 24 135 87 219 206 100 139 168 185 322 215 168 33 243 72 306 157 43 60 53
54 77 -44z m-6034 74 c0 -4 22 -33 49 -63 62 -69 126 -101 261 -128 168 -35
267 -95 339 -206 88 -137 157 -201 244 -227 51 -15 84 -56 153 -189 32 -61 79
-134 104 -162 l44 -50 -75 5 c-96 6 -159 37 -336 163 -169 120 -211 142 -309
154 -247 32 -420 135 -497 298 -31 65 -32 73 -32 188 0 91 4 133 18 173 10 28
23 52 28 52 5 0 9 -4 9 -8z m6122 -658 c27 -112 28 -335 3 -424 -40 -141 -102
-237 -198 -300 -72 -48 -116 -61 -211 -61 -77 0 -133 16 -286 82 -70 30 -84
32 -215 37 -136 4 -145 3 -285 -33 -162 -41 -307 -55 -377 -36 -24 7 -43 16
-43 20 0 13 123 124 205 185 52 39 88 57 140 71 80 21 187 74 266 132 97 71
183 129 233 157 57 32 179 56 281 56 161 0 283 45 390 144 33 30 64 54 70 52
5 -1 17 -38 27 -82z m-6152 11 c34 -37 125 -90 185 -109 28 -9 129 -22 226
-30 156 -13 183 -18 230 -42 61 -30 143 -85 239 -157 79 -59 226 -132 298
-148 58 -12 151 -76 272 -187 87 -81 81 -87 -88 -87 -114 1 -142 5 -277 39
-132 34 -163 38 -263 38 -125 -1 -140 -4 -292 -67 -144 -60 -212 -73 -292 -56
-90 18 -145 48 -210 113 -99 100 -158 264 -158 440 0 73 25 254 41 296 l9 23
28 -19 c15 -11 38 -32 52 -47z m5299 -786 c91 -16 113 -29 216 -129 126 -123
153 -135 285 -134 92 1 114 5 180 32 93 37 95 34 86 -91 -18 -236 -162 -455
-363 -548 -125 -58 -326 -58 -448 0 -86 41 -134 87 -249 240 -57 75 -121 153
-142 174 -41 39 -126 87 -155 87 -26 0 -175 37 -259 64 -150 49 -333 132 -327
149 6 19 143 89 232 119 80 27 104 30 210 31 98 0 137 -5 216 -26 l97 -26 53
21 c117 44 248 57 368 37z m-4264 -24 c33 -9 78 -23 101 -31 36 -14 45 -14 84
0 25 8 92 23 149 32 90 15 116 16 189 5 47 -6 112 -21 146 -33 75 -25 189 -83
210 -107 15 -17 12 -20 -61 -56 -130 -62 -246 -103 -415 -144 -218 -54 -220
-55 -395 -285 -149 -194 -228 -251 -381 -278 -294 -50 -579 153 -662 473 -18
69 -27 218 -14 232 3 3 27 -4 52 -15 84 -37 207 -58 271 -46 82 15 122 39 226
139 97 92 135 115 215 130 65 12 216 4 285 -16z m-450 -1159 c56 -27 136 -106
153 -151 6 -16 13 -102 16 -190 6 -183 22 -252 83 -352 57 -92 106 -146 219
-239 146 -120 180 -171 229 -335 14 -47 33 -93 43 -101 26 -24 90 -41 124 -34
103 20 72 103 -88 237 -117 98 -148 133 -187 209 -30 60 -32 72 -31 160 0 60
7 119 19 160 27 98 35 102 60 32 42 -117 104 -192 254 -311 106 -84 148 -158
185 -321 41 -182 47 -199 82 -230 42 -37 107 -42 124 -11 32 60 -8 155 -110
267 -138 151 -189 266 -197 439 -4 109 12 244 31 248 4 1 22 -29 39 -68 44
-102 123 -216 228 -330 203 -221 237 -287 280 -540 15 -91 35 -132 72 -151 27
-15 32 -14 55 3 31 23 44 65 35 113 -12 69 -85 218 -177 363 -169 267 -200
450 -113 660 9 20 20 37 25 37 4 0 16 -26 26 -57 41 -130 93 -209 256 -388
141 -156 145 -169 169 -537 11 -157 22 -195 66 -224 37 -24 95 -21 118 7 38
47 5 182 -93 389 -87 185 -104 231 -121 343 -16 105 6 270 53 390 15 39 25 34
37 -23 13 -61 52 -140 138 -278 162 -263 195 -365 199 -617 1 -88 3 -168 3
-179 1 -10 18 -36 40 -57 30 -31 46 -39 74 -39 52 0 82 14 112 54 26 35 27 37
29 213 3 254 31 349 172 584 106 176 141 246 158 311 14 55 30 71 39 41 3 -10
16 -52 28 -93 19 -62 23 -99 24 -215 0 -170 -7 -196 -115 -425 -135 -283 -146
-420 -35 -420 88 0 112 53 125 270 14 220 27 307 57 362 14 25 72 99 130 164
134 152 190 236 225 343 16 47 31 87 33 89 2 2 12 -13 23 -35 58 -115 69 -269
27 -397 -30 -93 -45 -123 -148 -296 -93 -155 -154 -283 -163 -339 -13 -82 35
-145 91 -119 38 17 53 48 70 145 49 268 82 332 279 546 116 126 167 199 223
316 34 71 47 91 54 79 17 -31 31 -166 26 -253 -9 -155 -64 -271 -200 -426 -88
-100 -116 -154 -117 -220 0 -54 13 -69 60 -69 56 0 103 51 123 132 9 35 25
101 36 148 30 122 82 221 138 267 199 163 247 218 292 333 32 84 39 81 66 -25
26 -102 24 -227 -4 -290 -33 -75 -92 -146 -178 -216 -94 -77 -138 -123 -159
-167 -20 -42 -13 -59 32 -78 32 -13 41 -13 90 1 61 17 75 37 100 134 21 78 65
170 105 215 18 21 65 64 103 94 153 122 247 244 290 376 22 65 27 104 32 244
8 189 15 214 84 276 62 56 113 76 196 76 93 0 148 -27 181 -90 33 -61 30 -107
-9 -166 -41 -61 -109 -97 -193 -104 l-60 -5 -7 -147 c-17 -380 -87 -649 -221
-848 -125 -186 -250 -291 -507 -427 -189 -99 -379 -165 -625 -217 -44 -10 -98
-21 -120 -26 -22 -5 -78 -16 -125 -25 -306 -56 -496 -108 -627 -171 -94 -46
-152 -91 -199 -155 l-38 -52 -15 24 c-80 123 -235 213 -476 275 -118 30 -183
44 -420 89 -372 70 -561 130 -795 252 -195 101 -250 137 -349 229 -251 232
-367 541 -389 1034 l-7 155 -66 11 c-80 13 -142 46 -183 97 -27 34 -31 47 -31
100 0 49 5 69 24 96 51 72 187 94 286 47z m2785 -626 c-12 -33 -59 -115 -103
-183 -44 -67 -91 -145 -104 -173 -31 -68 -46 -178 -47 -359 -2 -165 -15 -214
-70 -264 -37 -34 -66 -18 -102 56 -28 55 -29 65 -30 203 -2 166 -16 294 -41
360 -18 47 -69 135 -136 234 -45 67 -101 185 -92 194 16 17 265 -131 324 -192
19 -20 40 -36 46 -36 6 0 24 14 41 31 44 47 110 92 209 144 50 26 94 52 100
56 5 5 13 5 18 0 6 -6 1 -33 -13 -71z m-2545 -1927 c100 -36 152 -117 139
-218 l-7 -47 -41 6 c-23 4 -58 12 -78 18 -36 11 -38 13 -38 55 0 30 -6 49 -20
63 -42 42 -120 12 -120 -46 0 -39 25 -84 78 -139 84 -88 122 -139 138 -187 14
-44 14 -52 -1 -105 -35 -120 -106 -170 -230 -160 -92 7 -192 50 -226 98 -21
29 -24 45 -24 116 0 45 3 85 8 89 4 4 41 -1 82 -11 l75 -18 0 -58 c0 -48 4
-60 22 -73 31 -22 84 -20 108 4 46 46 21 105 -106 248 -81 91 -102 145 -86
219 14 65 49 116 100 143 49 25 158 27 227 3z m4604 -3 c49 -24 87 -70 102
-121 16 -50 9 -57 -70 -74 l-62 -13 -24 48 c-31 60 -69 79 -114 56 -58 -30
-63 -72 -31 -235 28 -144 68 -258 98 -281 29 -24 79 -26 127 -6 38 16 39 20
25 86 -22 100 -16 92 -64 85 -48 -8 -50 -6 -61 66 l-7 44 79 18 c43 10 94 20
113 23 l36 6 42 -179 c23 -98 42 -183 42 -189 0 -5 -46 -27 -102 -48 -134 -50
-251 -60 -315 -27 -46 23 -90 81 -116 151 -35 95 -69 249 -74 336 -7 107 12
164 69 208 82 62 232 85 307 46z m-4134 -106 c44 -8 107 -20 140 -26 33 -6 64
-14 69 -19 5 -4 3 -30 -4 -59 l-12 -52 -52 7 c-28 4 -80 13 -116 21 -36 7 -68
10 -72 6 -7 -8 -28 -115 -28 -147 0 -19 9 -23 73 -35 39 -7 88 -16 107 -19 19
-4 35 -12 34 -19 -1 -7 -2 -27 -3 -44 -3 -61 -7 -63 -126 -43 -58 9 -108 15
-111 12 -8 -7 -38 -197 -32 -202 3 -3 43 -12 89 -21 170 -32 154 -24 150 -74
-4 -57 -17 -82 -39 -76 -9 3 -98 19 -197 36 -99 17 -183 34 -187 38 -6 6 38
271 108 651 l17 93 56 -6 c31 -4 92 -13 136 -22z m3593 -46 c6 -35 18 -102 27
-150 30 -174 47 -264 60 -343 32 -175 33 -185 21 -193 -6 -4 -51 -14 -99 -23
-98 -18 -102 -17 -133 44 -9 18 -51 91 -94 162 -43 72 -104 177 -135 235 -31
58 -54 94 -51 80 15 -74 105 -529 108 -550 3 -24 -1 -26 -62 -36 -47 -8 -68
-8 -76 0 -7 6 -17 43 -22 81 -6 39 -18 108 -26 155 -9 47 -22 123 -30 170 -8
47 -23 128 -32 180 -10 52 -18 108 -18 125 l-1 30 99 17 c55 9 103 15 106 13
4 -2 37 -57 75 -122 37 -65 89 -154 115 -198 26 -44 60 -104 76 -134 15 -29
30 -48 32 -42 3 10 -16 114 -78 431 -11 52 -17 97 -14 100 7 6 92 27 120 29
17 1 22 -8 32 -61z m-3140 -40 c91 -10 103 -14 107 -32 2 -12 16 -122 30 -246
15 -124 29 -241 32 -260 7 -43 7 -42 61 130 22 69 57 178 78 243 20 66 43 121
49 123 7 3 64 -1 126 -8 l114 -14 0 -54 c-1 -58 -63 -665 -71 -689 -3 -10 -20
-12 -69 -9 -36 2 -69 8 -73 13 -8 9 -2 76 43 436 10 75 15 144 13 155 -2 10
-37 -80 -78 -201 -40 -121 -85 -254 -99 -295 l-26 -75 -72 1 c-40 0 -76 3 -80
7 -3 4 -10 35 -14 70 -38 300 -70 541 -74 545 -8 8 -14 -41 -31 -248 -9 -113
-20 -236 -23 -275 l-6 -70 -60 0 c-33 0 -68 4 -79 8 -20 8 -20 7 9 282 8 72
21 202 30 290 9 88 18 166 20 173 5 15 15 15 143 0z m2399 -268 c51 -129 116
-293 144 -363 28 -71 49 -130 48 -131 -2 -2 -38 -8 -79 -13 -82 -12 -94 -7
-107 47 -3 14 -14 43 -23 66 l-18 40 -83 -8 c-122 -11 -127 -13 -133 -51 -3
-17 -9 -54 -13 -82 l-8 -50 -73 -9 c-40 -4 -76 -5 -79 -2 -6 6 11 120 53 356
30 170 53 308 61 368 3 24 12 46 19 49 17 6 152 21 179 19 16 -1 36 -44 112
-236z m-1325 182 c7 -7 35 -110 108 -397 22 -88 52 -202 66 -253 14 -50 22
-97 19 -102 -8 -12 -135 -13 -153 -1 -8 5 -20 39 -28 77 -8 40 -22 74 -32 82
-11 9 -46 12 -111 10 l-94 -3 -22 -80 -21 -80 -59 -3 c-79 -4 -109 4 -100 26
4 9 13 37 20 62 68 236 199 658 208 669 9 10 31 12 102 6 49 -3 93 -10 97 -13z
m686 -19 c47 -23 73 -74 79 -156 7 -81 -10 -139 -47 -171 -17 -13 -30 -27 -30
-29 0 -3 13 -10 29 -17 44 -18 61 -66 72 -198 5 -64 10 -126 11 -137 3 -18 -4
-20 -74 -23 -94 -3 -93 -4 -101 135 -3 55 -11 114 -19 129 -15 32 -57 47 -106
38 l-32 -6 6 -154 7 -154 -80 0 -80 0 -7 108 c-14 219 -25 637 -18 644 9 9
153 16 265 12 59 -2 100 -9 125 -21z" />
            <path d="M7892 12228 c-23 -46 -62 -119 -85 -163 -24 -44 -58 -109 -77 -144
l-34 -63 20 -17 c12 -9 40 -23 64 -31 39 -13 45 -12 79 6 48 26 130 151 184
284 19 47 25 118 12 139 -9 16 -95 71 -110 71 -5 0 -29 -37 -53 -82z" />
            <path d="M5973 11877 c3 -8 24 -71 47 -140 23 -70 48 -127 54 -127 16 0 101
54 111 70 5 9 -28 46 -96 111 -100 94 -127 114 -116 86z" />
            <path d="M8767 11698 c-29 -40 -56 -78 -60 -85 -10 -17 75 -73 110 -73 33 0
70 34 98 89 14 29 15 37 4 58 -12 23 -79 83 -93 83 -3 0 -29 -33 -59 -72z" />
            <path d="M9295 11331 c-48 -30 -168 -159 -229 -245 -64 -89 -70 -123 -31 -161
50 -51 100 -30 215 92 105 112 170 207 170 249 0 66 -68 102 -125 65z" />
            <path d="M6480 10490 c0 -10 5 -64 11 -120 27 -244 -37 -402 -191 -473 -59
-28 -77 -31 -190 -35 -69 -2 -155 1 -190 6 -36 6 -94 16 -129 22 -35 6 -65 9
-68 7 -2 -3 16 -36 40 -73 93 -144 127 -235 127 -337 0 -121 -57 -199 -192
-263 -57 -28 -86 -37 -225 -74 -24 -6 -72 -13 -108 -17 -36 -3 -65 -9 -65 -13
0 -4 44 -45 98 -92 201 -174 282 -332 251 -489 -23 -114 -120 -239 -284 -363
-64 -48 -82 -66 -66 -66 38 0 318 -57 341 -69 9 -5 31 -12 50 -16 19 -4 41
-11 50 -16 8 -4 46 -22 83 -39 73 -34 143 -85 220 -159 55 -52 55 -54 -13 99
-221 497 -271 914 -151 1262 11 31 42 101 70 155 145 282 428 551 931 887 96
65 176 121 178 126 3 9 -20 15 -118 30 -161 24 -265 54 -388 111 -35 16 -65
29 -68 29 -2 0 -4 -9 -4 -20z" />
            <path d="M7895 10488 c-55 -29 -216 -85 -267 -93 -24 -4 -59 -11 -78 -15 -19
-5 -68 -14 -107 -20 -40 -7 -73 -15 -73 -18 0 -4 76 -58 169 -120 658 -439
943 -758 1047 -1171 24 -93 27 -126 28 -271 0 -99 -5 -193 -13 -235 -42 -218
-96 -394 -182 -592 -28 -65 -58 -134 -66 -152 -14 -34 -13 -33 47 22 74 69
157 126 225 156 28 12 59 26 70 31 59 26 380 100 437 100 15 0 2 14 -48 52
-101 75 -207 182 -248 247 -19 31 -42 88 -52 125 -14 58 -15 76 -4 124 30 140
107 248 288 402 34 29 62 57 62 61 0 5 -15 9 -33 9 -38 0 -197 32 -269 54
-133 41 -256 135 -277 212 -18 65 -13 148 14 225 23 66 108 221 144 263 15 18
14 18 -39 11 -30 -3 -73 -12 -95 -18 -22 -6 -114 -11 -205 -12 -149 0 -171 2
-221 23 -165 67 -240 238 -210 485 7 56 15 110 17 120 7 23 -11 21 -61 -5z" />
            <path d="M7153 9507 c-79 -191 -130 -372 -165 -577 -18 -102 -21 -167 -22
-355 0 -204 3 -247 26 -380 37 -210 52 -412 52 -680 -1 -379 -35 -657 -111
-898 -38 -120 -66 -134 -139 -67 -47 43 -73 49 -98 24 -39 -39 2 -127 77 -163
53 -25 118 -27 302 -6 203 23 324 18 533 -21 19 -4 32 -2 32 4 0 6 -23 66 -51
134 -184 448 -263 720 -290 998 -13 125 -6 410 12 495 95 465 103 862 25 1200
-35 150 -114 386 -132 392 -5 1 -28 -43 -51 -100z m71 -284 c55 -245 71 -452
56 -716 -6 -100 -13 -193 -15 -207 -12 -61 -45 -433 -45 -511 0 -113 26 -464
46 -609 27 -204 77 -428 129 -579 14 -41 25 -78 25 -83 0 -10 -175 -11 -324
-1 -103 6 -107 7 -101 27 103 355 124 616 131 1631 3 336 9 655 14 710 12 123
28 240 40 280 4 17 11 42 14 58 4 15 10 27 15 27 5 0 11 -12 15 -27z" />
            <path d="M7115 6316 c-15 -11 -18 -25 -17 -78 2 -85 -26 -144 -85 -176 l-43
-23 -2 -77 c-2 -111 0 -127 23 -166 23 -40 21 -79 -8 -171 -26 -81 -21 -160
16 -232 17 -35 27 -65 21 -68 -5 -3 -32 6 -59 20 -28 14 -61 25 -75 25 -36 0
-66 -43 -66 -95 0 -37 10 -56 75 -146 139 -191 232 -269 321 -269 33 0 47 7
76 35 19 19 47 60 62 91 46 93 56 178 53 432 -2 227 -2 227 26 306 16 43 31
109 34 146 l6 67 -48 49 c-79 82 -92 127 -95 337 0 14 -195 8 -215 -7z m149
-267 l38 -11 -6 -46 c-31 -236 -39 -503 -18 -606 7 -33 12 -115 12 -183 0
-118 -1 -125 -25 -148 -48 -48 -163 -27 -226 42 -61 67 -72 102 -42 135 29 32
71 23 124 -27 26 -25 53 -45 59 -45 17 0 11 82 -11 166 -18 66 -22 116 -26
309 -6 303 14 425 71 425 6 0 28 -5 50 -11z" />
            <path d="M4356 10538 c-31 -17 -65 -62 -58 -74 4 -6 38 -37 75 -69 65 -54 69
-56 87 -40 10 9 26 32 34 50 20 42 11 70 -38 113 -38 33 -68 39 -100 20z" />
            <path d="M10910 9197 c-177 -79 -310 -155 -334 -189 -23 -33 -20 -81 7 -106
42 -40 100 -27 272 59 194 98 239 153 184 223 -16 21 -29 26 -62 25 -23 0 -53
-5 -67 -12z" />
            <path d="M11255 8593 c-11 -3 -24 -8 -30 -12 -5 -4 -32 -16 -60 -26 -27 -10
-54 -21 -58 -25 -10 -9 14 -70 37 -93 37 -37 159 -3 172 48 7 26 -17 108 -32
111 -5 1 -18 -1 -29 -3z" />
            <path d="M11350 7958 c-222 -64 -312 -104 -330 -149 -23 -55 20 -109 85 -109
53 0 269 62 353 100 59 28 82 54 82 93 0 52 -34 77 -101 76 -30 -1 -70 -6 -89
-11z" />
            <path d="M4613 5140 c-68 -41 -35 -150 44 -150 77 0 109 85 54 141 -35 34 -54
36 -98 9z" />
            <path d="M9689 5131 c-38 -39 -38 -74 1 -113 27 -26 36 -30 68 -25 70 12 97
92 47 142 -34 35 -78 33 -116 -4z" />
            <path d="M8150 2258 c0 -3 -9 -66 -20 -140 -11 -73 -20 -139 -20 -146 0 -11
15 -12 68 -7 37 4 70 10 74 14 8 7 -77 258 -93 276 -5 5 -9 6 -9 3z" />
            <path d="M6896 2210 c-3 -8 -19 -67 -36 -130 -17 -63 -33 -123 -36 -132 -5
-16 3 -18 70 -18 62 0 76 3 76 15 0 24 -51 248 -60 265 -8 13 -9 13 -14 0z" />
            <path d="M7470 2183 c0 -49 4 -94 9 -102 7 -10 22 -12 57 -8 68 7 87 33 82
111 -5 72 -21 86 -95 86 l-53 0 0 -87z" />
        </g>
    </svg>
</template>
